import { LocalNotFoundError } from '../general.errors';

export class TakeNotFoundError extends LocalNotFoundError {
    constructor(message: string) {
        super(message);
        this.name = 'TakeNotFoundError';
    }
}
